module.exports = function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Veuillez ouvrir une session Sephora',
        termsOfUseLink: 'Conditions d’utilisation',
        privacyPolicyLink: 'Politique de confidentialité'
    };

    return resources[label];
};
